<template>
  <div class="w-full flex bg-white border-round">
    <div class="flex items-center w-full">
      <div class="w-4/12 p-16">
        <h1 class="text-3xl mb-0 text-dark font-semibold">Brand Profile</h1>
        <p class="fsize14 text-gray mb-0">Setup your brands colors</p>

        <div class="shadow-lg border-round mt-8 px-8 pt-8 pb-32 relative">
          <div>
            <small class="text-sm text-primary font-semibold">Step 4</small>
            <h1 class="fsize21 col-4f mb-0 font-semibold">Brand Colors</h1>
            <p class="fsize14 col-4f mb-0">
              Pick a color pallate of your brand
            </p>
          </div>

          <div class="mt-4">
            <div class="input-field">
              <small class="fsize12 bg-white text-dark font-medium"
                >Primary Color <span class="text-danger">*</span></small
              >

              <div class="relative mt-2">
                <el-input
                  type="text"
                  id="name"
                  :value="primaryColor"
                  v-model="primaryColor"
                  required
                  placeholder="Hex or rgba"
                  class="inputstyle"
                />

                <input
                  type="color"
                  class="colordesign"
                  v-model="primaryColor"
                />
                <p v-if="submitted == true">
                  {{ primaryColor === "" ? "This Field is required" : "" }}
                </p>
              </div>
            </div>
            <div class="input-field mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Secondary Color <span class="text-danger">*</span></small
              >

              <div class="relative mt-2">
                <el-input
                  type="text"
                  id="name"
                  :value="secondaryColor"
                  v-model="secondaryColor"
                  required
                  placeholder="Hex or rgba"
                  class="inputstyle"
                />

                <input
                  type="color"
                  class="colordesign"
                  v-model="secondaryColor"
                />
                <p v-if="submitted == true">
                  {{ secondaryColor === "" ? "This Field is required" : "" }}
                </p>
              </div>
            </div>
            <div class="input-field mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Tertiary Color <span class="text-danger">*</span></small
              >

              <div class="relative mt-2">
                <el-input
                  type="text"
                  id="name"
                  :value="tertiaryColor"
                  v-model="tertiaryColor"
                  required
                  placeholder="Hex or rgba"
                  class="inputstyle"
                />

                <input
                  type="color"
                  class="colordesign"
                  v-model="tertiaryColor"
                />
                <p v-if="submitted == true">
                  {{ tertiaryColor === "" ? "This Field is required" : "" }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="absolute bottom-0 margin-niche right-0 left-0 w-full flex justify-between"
          >
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-product/Default.svg"
                class="mar-left"
                @click="handleClick('fonts')"
              />
            </div>
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class="mar-right"
                @click="handleClick('step')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="w-8/12 bg-primary p-12 z-50 relative">
        <div class="px-10 pt-10 pb-16 border-round z-50 bg-white">
          <div class="block">
            <small class="text-lg text-primary font-semibold">Presets</small>
            <h1 class="text-xl text-dark mb-0 font-semibold">
              Having trouble picking the right pallate? We got you covered
            </h1>
            <div class="mt-6">
              <!-- <swiper :options="swiperOption" class="related-product-swiper">
                <swiper-slide
                  v-for="item in related_items"
                  :key="item.objectId"
                  class="m-2 cursor-pointer"
                > -->
              <!-- Item Image -->
              <!-- <div class="bg-white shadow-lg border-box border-round">
                    <img
                      :src="item.image"
                      alt="color"
                      class="w-full rounded-t-lg h-32"
                    />
                    <h1
                      class="text-dark fsize14 text-center p-3 mb-0 font-semibold"
                    >
                      {{ item.robo }}
                    </h1>
                  </div>
                </swiper-slide> -->

              <swiper :options="swiperOption" class="related-product-swiper">
                <swiper-slide class="m-2 cursor-pointer">
                  <div class="bg-white shadow-lg border-box border-round">
                    <div
                      :style="{ 'background-color': primaryColor }"
                      class="w-full rounded-t-lg h-32"
                    ></div>
                    <h1
                      class="text-dark fsize14 text-center p-3 mb-0 font-semibold"
                    >
                      {{ this.primaryColor }}
                    </h1>
                  </div>
                </swiper-slide>
                <swiper-slide class="m-2 cursor-pointer">
                  <div class="bg-white shadow-lg border-box border-round">
                    <div
                      :style="{ 'background-color': secondaryColor }"
                      class="w-full rounded-t-lg h-32"
                    ></div>
                    <h1
                      class="text-dark fsize14 text-center p-3 mb-0 font-semibold"
                    >
                      {{ this.secondaryColor }}
                    </h1>
                  </div>
                </swiper-slide>
                <swiper-slide class="m-2 cursor-pointer">
                  <div class="bg-white shadow-lg border-box border-round">
                    <div
                      :style="{ 'background-color': tertiaryColor }"
                      class="w-full rounded-t-lg h-32"
                    ></div>
                    <h1
                      class="text-dark fsize14 text-center p-3 mb-0 font-semibold"
                    >
                      {{ this.tertiaryColor }}
                    </h1>
                  </div>
                </swiper-slide>

                <!-- <div
                  class="swiper-button-prev cust-hidden"
                  slot="button-prev"
                ></div>
                <div
                  class="swiper-button-next cust-hidden"
                  slot="button-next"
                ></div> -->
              </swiper>
            </div>
          </div>
          <div class="mt-8 flex items-center w-full">
            <div class="w-2/12 p-2">
              <p
                class="text-2xl flex justify-center items-center font-semibold col-4f mb-0 cross"
              >
                Preview
              </p>
            </div>
            <div
              class="w-10/12 bg-white shadow-lg relative flex border-box border-round"
            >
              <div
                :style="{ 'background-color': this.secondaryColor }"
                class="w-3/12 border-round"
              ></div>
              <div
                class="w-9/12 py-20 pl-24 pr-6 flex justify-end items-center"
              >
                <div>
                  <small class="col-bcbcbc text-sm">This is a Subheading</small>
                  <h1 class="text-2xl mb-0 col-4f font-semibold">
                    This is a Heading
                  </h1>
                  <p class="fsize14 col-bcbcbc mb-0 mt-2">
                    Finally this is an example of how your paragraphs will look
                    like with this your design preferences:)
                  </p>
                  <vs-button
                    variant="primary"
                    :style="{
                      'background-color': `${primaryColor} !important`,
                    }"
                    class="rounded-none mt-4 border-0 text-white font-medium lg:py-3 md:py-3 py-2 px-6 sm-fsize14"
                  >
                    This is Button
                  </vs-button>
                </div>
              </div>
              <div class="absolute topyfi">
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/Frame 1000002845.png"
                  class=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="absolute top-0 left-0 p-4">
          <div class="grid grid-cols-1 gap-4">
            <marquee
              class="bg-transparent text-white font-semibold mb-0"
              scrollamount="20"
            >
              <div class="grid grid-cols-1 gap-5">
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
                  class="w-full height-marf"
                />
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
                  class="w-full height-marf"
                />
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
                  class="w-full height-marf"
                />
              </div>
            </marquee>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
// import getColors from "get-image-colors";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      colorCode: [],
      primaryColor: "",
      secondaryColor: "",
      tertiaryColor: "",
      swiperOption: {
        slidesPerView: 4.2,
        observer: true,
        observeParents: true,
        spaceBetween: 25,
        breakpoints: {
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      related_items: [
        {
          name: "Template 1",
          image: require("@/assets/images/banh.png"),
          robo: "Color pallate 1",
        },
        {
          name: "Template 2",
          image: require("@/assets/images/banh.png"),
          robo: "Color pallate 2",
        },
        {
          name: "Template 3",
          image: require("@/assets/images/banh.png"),
          robo: "Color pallate 3",
        },
        {
          name: "Template 4",
          image: require("@/assets/images/banh.png"),
          robo: "Color pallate 4",
        },
        {
          name: "Template 5",
          image: require("@/assets/images/banh.png"),
          robo: "Color pallate 5",
        },
        {
          name: "Template 6",
          image: require("@/assets/images/banh.png"),
          robo: "Color pallate 6",
        },
      ],
      products: [],
      submitted: false,
      completed: false,
    };
  },
  computed: {
    ...mapState("brandProfile", { brandProfile: "brandProfile" }),
    ...mapState("brandProfile", ["colorCodeSuggest"]),
    ...mapState("user", { selectedProject: "selectedProject" }),
  },
  async mounted() {
    // console.log(this.brandProfile.hasOwnProperty("primaryColor"));
    // console.log(this.brandProfile);
    this.getColorCode();
    this.completed = this.brandProfile.isCompleted;
    if (
      this.brandProfile.hasOwnProperty("primaryColor") &&
      this.brandProfile.hasOwnProperty("secondaryColor") &&
      this.brandProfile.hasOwnProperty("tertiaryColor")
    ) {
      this.primaryColor = this.brandProfile.hasOwnProperty("primaryColor")
        ? this.brandProfile.primaryColor
        : this.colorCodeSuggest[0].hex;
      // this.brandProfile.primaryColor;
      this.secondaryColor = this.brandProfile.hasOwnProperty("secondaryColor")
        ? this.brandProfile.secondaryColor
        : this.colorCodeSuggest[1].hex;
      // this.brandProfile.secondaryColor;
      this.tertiaryColor = this.brandProfile.hasOwnProperty("tertiaryColor")
        ? this.brandProfile.tertiaryColor
        : this.colorCodeSuggest[2].hex;
    }
    // this.IScompleted();
  },
  methods: {
    async getColorCode() {
      try {
        console.log("call");
        // let v = new Vibrant(image);
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.src =
          "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png";
        let color = new ColorThief();
        let colorPal;
        if (image.complete) {
          console.log("true");
          colorPal = color.getColor(image);
        } else {
          console.log("false");
          image.onload = function () {
            colorPal = color.getColor(image);
          };
        }
        console.log(colorPal, "uwuwuwu");
      } catch (error) {
        console.log(error);
      }
    },
    // IScompleted() {
    //   if (this.completed === true) {
    //     this.$router.push({ name: "dashboard" });
    //   }
    // },
    async handleClick(name) {
      this.submitted = true;
      let payloadColor = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        primaryColor: this.primaryColor,
        secondaryColor: this.secondaryColor,
        tertiaryColor: this.tertiaryColor,
      };

      if (
        !(
          this.primaryColor === this.brandProfile.primaryColor &&
          this.secondaryColor === this.brandProfile.secondaryColor &&
          this.tertiaryColor === this.brandProfile.tertiaryColor
        )
      ) {
        let data = await this.$store.dispatch(
          "brandProfile/uploadBrandProfile",
          payloadColor
        );
        let payloadBrand = {
          projectId: this.selectedProject._id,
          projectName: this.selectedProject.projectName,
        };
        await this.$store.dispatch(
          "brandProfile/getBrandProfile",
          payloadBrand
        );
        console.log(data);
      }
      if (
        this.primaryColor !== "" &&
        this.secondaryColor !== "" &&
        this.tertiaryColor !== ""
      ) {
        this.$router.push({ name: name });
      }
    },
  },
};
</script>
